import React from "react";
import {ReactSession} from "react-client-session";
import { Modal, ModalBody } from 'reactstrap';

import { Helpers } from "../config/Helpers";
import {toast} from "react-toastify";
import {decode as base64_decode, encode as base64_encode} from "base-64";
import $ from "jquery";
import queryString from "query-string";

class Checkout extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            sessKodeNasabah: (ReactSession.get("sess_kodenasabah")) ? ReactSession.get("sess_kodenasabah") : '',
            step: 'cart', // cart | delivery | payment
            summaryData: '',
            paymentData: [],
            warungData: [],
            orderData: [],
            orderTotal: 0,
            orderTotalGrosir: 0,
            orderGrandTotal: 0,
            orderTotalKomisi: 0,
            orderTotalBerat: 0,
            orderKomisiDigunakan: 0,
            orderBBXTabunganDigunakan: 0,
            orderBBXPoinDigunakan: 0,
            orderDeliveryType: (ReactSession.get("sess_order_delivery")) ? ReactSession.get("sess_order_delivery") : 'Ambil Sendiri',
            orderDeliveryLocation: (ReactSession.get("sess_order_kodelokasi")) ? ReactSession.get("sess_order_kodelokasi") : '',
            orderPaymentObj: '',
            orderPaymentMethod: '',
            orderPaymentMethodType: '',
            orderPaymentCharge: 0,
            orderPaymentFee: '',
            orderWarung: '',
            orderWarungObj: '',
            orderCatatan: '',
            showWarungModal: false,
            warungSearch: '',
            orderType: (ReactSession.get("order_type")) ? ReactSession.get("order_type") : 'Grosir',
            branchCode: (ReactSession.get("branch_code")) ? ReactSession.get("branch_code") : 'CBNG-18-020001',
            orderLocPinPoint: (ReactSession.get("sess_order_pinpoint")) ? ReactSession.get("sess_order_pinpoint") : '',
            orderLocJarak: (ReactSession.get("sess_order_jarak")) ? ReactSession.get("sess_order_jarak") : '0',
            orderLocJasaKirim: (ReactSession.get("sess_order_jasakirim")) ? ReactSession.get("sess_order_jasakirim") : '0',
            isCommissionChecked: false,
            saldoCommission: 0,
            typeCommission: 'Pilih',
            isBBXTabunganChecked: false,
            saldoBBXTabungan: 0,
            isBBXPoinChecked: false,
            saldoBBXPoin: 0,
            urlParam: queryString.parse(window.location.search),
            kodeMarketPlaceDetail: '',
            orderShipmentMethod: '',
            orderShipmentMethodObj: '',
            generateShipmentMethodList: [],
            lalamoveServiceList: [],
            showDeliveryPicker: false,
            showCourierPicker: false,
            loadingCourier: false,
            loadingQuotation: false,
            koinWorksTenor: '30',
            id_store_bbx: '',
            password_waroq: ''
        }
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.getSummary();
            this.getWarung();
            this.showCart();
            this.handleRadioChange(this.state.orderDeliveryType);
        }
    }

    getSummary = () => {
        Helpers.getSummary(this.state.sessUserCode, this.state.sessKodeNasabah).then(res => {
            this.setState({
                summaryData: res[0],
                saldoCommission: res[0].commission_now_raw,
                saldoBBXTabungan: res[0].bbx_tabungan,
                saldoBBXPoin: res[0].bbx_poin,
                id_store_bbx: res[0].id_store_bbx,
                kodeMarketPlaceDetail: (this.state.urlParam.joinid) ? base64_decode(this.state.urlParam.joinid) : '',
            }, () => {
                this.callPaymentMethod();

                if(this.state.orderDeliveryLocation && this.state.orderDeliveryType == 'Biteship'){
                    this.callShipmentMethod();
                }
            });
        })
    };

    getWarung = () => {
        Helpers.getWarung('','').then(res => {
            this.setState({
                warungData: res
            });
        })
    };

    callPaymentMethod = () => {
        Helpers.getListPaymentChannel(
            '',
            parseInt(this.state.orderGrandTotal)
        ).then(res => {
            this.setState({
                paymentData: (res) ? res : []
            });
        })
    };

    callShipmentMethod = () => {
        this.setState({ loadingCourier: true });

        Helpers.getBiteshipRates(
            this.state.sessEmail,
            this.state.branchCode,
            this.state.orderDeliveryLocation,
            this.state.orderType
        ).then(res => {
            this.setState({
                generateShipmentMethodList: (res) ? res : [],
                loadingCourier: false
            });
        })
    };

    callLalamoveService = () => {
        this.setState({ loadingCourier: true });

        Helpers.GetLalamoveService(
            '',
            parseInt(this.state.orderTotalBerat) || 0,
            this.state.sessEmail
        ).then(res => {
            this.setState({
                lalamoveServiceList: (res) ? res : [],
                loadingCourier: false
            });
        })
    };

    handleSelectLalamoveService = (item) => {
        const serviceKey = item.ServiceKey || item.Servicekey || item.serviceKey || item.servicekey;
        const vehicleName = item.VehicleName || item.Vehiclename || item.vehicleName || item.vehiclename;
        const description = item.Description || item.description;

        this.setState({ loadingQuotation: true });

        Helpers.GetLalamoveQuotation(
            this.state.sessUserCode,
            '',
            this.state.orderDeliveryLocation,
            this.state.branchCode,
            serviceKey
        ).then(res => {
            this.setState({ loadingQuotation: false });

            if(res && res.length > 0){
                const obj = res[0];
                let parsed = {};

                try {
                    parsed = JSON.parse(obj.ResponseJson);
                } catch(e) {
                    parsed = {};
                }

                if(obj.HttpStatus === '200' || obj.HttpStatus === '201'){
                    const price = (parsed.data && parsed.data.priceBreakdown) ? parseInt(parsed.data.priceBreakdown.total) : 0;

                    this.setState({
                        orderShipmentMethod: serviceKey,
                        orderShipmentMethodObj: {
                            courier_name: vehicleName,
                            courier_service_name: description,
                            duration: '',
                            price: price
                        },
                        orderLocJasaKirim: price,
                        showCourierPicker: false,
                    }, () => {
                        this.calculateTotal();
                    });
                }else{
                    toast.error((parsed.message) ? parsed.message : 'Gagal mendapatkan estimasi biaya Lalamove');
                }
            }else{
                toast.error('Gagal mendapatkan estimasi biaya Lalamove');
            }
        });
    };

    calculateTotal = () => {
        let jasa_kirim = (parseInt(this.state.orderTotal) > 1000000 && this.state.orderDeliveryType === 'Jasa Kurir') ? 0 : parseInt(this.state.orderLocJasaKirim);
        let total_harga_kj = parseInt(this.state.orderTotal) + jasa_kirim;
        let poinwaroq = parseInt(this.state.summaryData.commission_now_raw);
        let pointabungan = (parseInt(this.state.summaryData.bbx_tabungan) > 100000) ? parseInt(this.state.summaryData.bbx_tabungan)-100000 : 0;
        let poinbbx = parseInt(this.state.summaryData.bbx_poin);
        let payment = this.state.orderPaymentMethod;
        let paymenttype = this.state.orderPaymentMethodType;
        let paymentcharge = parseInt(this.state.orderPaymentCharge);
        let poinwaroqused = 0;
        let pointabunganused = 0;
        let poinbbxused = 0;
        let poinwaroqleft = poinwaroq;
        let pointabunganleft = pointabungan;
        let poinbbxleft = poinbbx;
        let jeniskomisi = '';

        if(this.state.orderPaymentObj){
            payment = this.state.orderPaymentObj.KodePaymentGateway;
            paymenttype = this.state.orderPaymentObj.JenisBank;
            paymentcharge = this.state.orderPaymentObj.FeeTotal;
        }

        if(this.state.isCommissionChecked && this.state.isBBXTabunganChecked && this.state.isBBXPoinChecked){
            jeniskomisi = "Potongan";

            if(poinwaroq >= total_harga_kj){
                payment = 'Saldo';
                poinwaroqused = total_harga_kj;
                poinwaroqleft = poinwaroq-total_harga_kj;

                this.setState({ isBBXTabunganChecked: false, isBBXPoinChecked: false });
            }else{
                poinwaroqused = poinwaroq;
                poinwaroqleft = 0;

                let sisaafterwaroq = total_harga_kj-poinwaroqused;

                if(pointabungan >= sisaafterwaroq){
                    payment = 'Saldo';
                    pointabunganused = sisaafterwaroq;
                    pointabunganleft = pointabungan-sisaafterwaroq;

                    this.setState({ isBBXPoinChecked: false });
                }else{
                    pointabunganused = pointabungan;
                    pointabunganleft = 0;

                    let sisaaftertabungan = sisaafterwaroq-pointabunganused;

                    if(poinbbx >= sisaaftertabungan){
                        payment = 'Saldo';
                        poinbbxused = sisaaftertabungan;
                        poinbbxleft = poinbbx-sisaaftertabungan;
                    }else{
                        poinbbxused = poinbbx;
                        poinbbxleft = 0;
                    }
                }
            }
        }else if(this.state.isCommissionChecked && this.state.isBBXTabunganChecked && !this.state.isBBXPoinChecked){
            jeniskomisi = "Potongan";

            if(poinwaroq >= total_harga_kj){
                payment = 'Saldo';
                poinwaroqused = total_harga_kj;
                poinwaroqleft = poinwaroq-total_harga_kj;

                this.setState({ isBBXTabunganChecked: false });
            }else{
                poinwaroqused = poinwaroq;
                poinwaroqleft = 0;

                let sisaafterwaroq = total_harga_kj-poinwaroqused;

                if(pointabungan >= sisaafterwaroq){
                    payment = 'Saldo';
                    pointabunganused = sisaafterwaroq;
                    pointabunganleft = pointabungan-sisaafterwaroq;
                }else{
                    pointabunganused = pointabungan;
                    pointabunganleft = 0;
                }
            }
        }else if(this.state.isCommissionChecked && !this.state.isBBXTabunganChecked && this.state.isBBXPoinChecked){
            jeniskomisi = "Potongan";

            if(poinwaroq >= total_harga_kj){
                payment = 'Saldo';
                poinwaroqused = total_harga_kj;
                poinwaroqleft = poinwaroq-total_harga_kj;

                this.setState({ isBBXTabunganChecked: false });
            }else{
                poinwaroqused = poinwaroq;
                poinwaroqleft = 0;

                let sisaafterwaroq = total_harga_kj-poinwaroqused;

                if(poinbbx >= sisaafterwaroq){
                    payment = 'Saldo';
                    poinbbxused = sisaafterwaroq;
                    poinbbxleft = poinbbx-sisaafterwaroq;
                }else{
                    poinbbxused = poinbbx;
                    poinbbxleft = 0;
                }
            }
        }else if(this.state.isCommissionChecked && !this.state.isBBXTabunganChecked && !this.state.isBBXPoinChecked){
            jeniskomisi = "Potongan";

            if(poinwaroq >= total_harga_kj){
                payment = 'Saldo';
                poinwaroqused = total_harga_kj;
                poinwaroqleft = poinwaroq-total_harga_kj;
            }else{
                poinwaroqused = poinwaroq;
                poinwaroqleft = 0;
            }
        }else if(!this.state.isCommissionChecked && this.state.isBBXTabunganChecked && this.state.isBBXPoinChecked){
            if(pointabungan >= total_harga_kj){
                payment = 'Saldo';
                pointabunganused = total_harga_kj;
                pointabunganleft = pointabungan-total_harga_kj;

                this.setState({ isBBXPoinChecked: false });
            }else{
                pointabunganused = pointabungan;
                pointabunganleft = 0;

                let sisaaftertabungan = total_harga_kj-pointabunganused;

                if(poinbbx >= sisaaftertabungan){
                    payment = 'Saldo';
                    poinbbxused = sisaaftertabungan;
                    poinbbxleft = poinbbx-sisaaftertabungan;
                }else{
                    poinbbxused = poinbbx;
                    poinbbxleft = 0;
                }
            }
        }else if(!this.state.isCommissionChecked && this.state.isBBXTabunganChecked && !this.state.isBBXPoinChecked){
            jeniskomisi = "Potongan";

            if(pointabungan >= total_harga_kj){
                payment = 'Saldo';
                pointabunganused = total_harga_kj;
                pointabunganleft = pointabungan-total_harga_kj;
            }else{
                pointabunganused = pointabungan;
                pointabunganleft = 0;
            }
        }else if(!this.state.isCommissionChecked && !this.state.isBBXTabunganChecked && this.state.isBBXPoinChecked){
            jeniskomisi = "Potongan";

            if(poinbbx >= total_harga_kj){
                payment = 'Saldo';
                poinbbxused = total_harga_kj;
                poinbbxleft = poinbbx-total_harga_kj;
            }else{
                poinbbxused = poinbbx;
                poinbbxleft = 0;
            }
        }

        let total_harga_by_flow = total_harga_kj + paymentcharge - poinwaroqused - pointabunganused - poinbbxused;

        if(payment === 'Saldo'){
            paymenttype = 'Saldo';
            paymentcharge = 0;
        }

        this.setState({
            typeCommission: jeniskomisi,
            orderPaymentMethodType: paymenttype,
            orderPaymentMethod: payment,
            orderGrandTotal: total_harga_by_flow,
            orderPaymentCharge: paymentcharge,
            orderKomisiDigunakan: poinwaroqused,
            saldoCommission: poinwaroqleft,
            orderBBXPoinDigunakan: poinbbxused,
            saldoBBXPoin: poinbbxleft,
            orderBBXTabunganDigunakan: pointabunganused,
            saldoBBXTabungan: pointabunganleft + ((parseInt(this.state.summaryData.bbx_tabungan) > 100000) ? 100000 : 0),
            orderLocJasaKirim: jasa_kirim
        }, () => {
            this.callPaymentMethod();
        });
    };

    showCart = () => {
        $("#preloader-active-x").css("display", "");
        Helpers.getProductDetails(this.state.sessEmail, '', this.state.branchCode, 'yes').then(res => {
            const allItems = res.filter(item => parseInt(item.QtyOrder) > 0);
            const checkedItems = allItems.filter(item => item.Checked === 't');

            this.setState({
                orderData: allItems
            }, () => {
                this.setState({
                    orderTotal: checkedItems.reduce((a,v) =>  a = a + ((this.state.orderType == 'Grosir') ? v.TotalHargaGrosirTerkecil : v.TotalHargaRetailTerkecil) , 0 ),
                    orderTotalGrosir: checkedItems.reduce((a,v) => a = a + v.TotalHargaGrosirTerkecil, 0),
                    orderGrandTotal: checkedItems.reduce((a,v) =>  a = a + ((this.state.orderType == 'Grosir') ? v.TotalHargaGrosirTerkecil : v.TotalHargaRetailTerkecil) , 0 ),
                    orderTotalKomisi: checkedItems.reduce((a,v) =>  a = a + ((this.state.orderType == 'Grosir') ? parseInt(v.KomisiGrosirFormat) : parseInt(v.KomisiRetailFormat)) , 0 ).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.'),
                    orderTotalBerat: checkedItems.reduce((a,v) =>  a = a + v.TotalBerat , 0 ).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')
                }, () => {
                    this.calculateTotal();
                    $("#preloader-active-x").css("display", "none");
                })
            });
        })
    };

    handleSubmitOrderTemp = (detailId, qtyUpdate, checked) => {
        Helpers.createOrderTemp(this.state.sessEmail, detailId, qtyUpdate, this.state.branchCode, 'yes', (checked === 't') ? 't' : 'f').then(res => {
            if(res[0].alert == 'success'){
                this.showCart();

                ReactSession.set("update_dropdown_cart", "t");
            }

            toast[res[0].alert](res[0].message);
        })
    };

    handleToggleChecked = (object) => {
        this.handleSubmitOrderTemp(object.DetailId, object.QtyOrder, (object.Checked === 't') ? 'f' : 't');
    };

    handleToggleSelectAll = () => {
        const allChecked = this.state.orderData.length > 0 && this.state.orderData.every(item => item.Checked === 't');
        this.handleSubmitOrderTemp('select_all', '0', allChecked ? 'f' : 't');
    };

    handleRadioChange = (object) => {
        if(object == 'Ambil Sendiri'){
            this.setState({
                orderDeliveryType: object,
                orderDeliveryLocation: '',
                orderLocPinPoint: '',
                orderLocJarak: '0',
                orderLocJasaKirim: '0',
                showDeliveryPicker: false,
            }, () => {
                ReactSession.set("sess_order_delivery", object);

                this.calculateTotal();
            });
        }else if(object == 'Jasa Kurir' || object == 'Biteship' || object == 'Lalamove'){
            this.setState({
                orderDeliveryType: object,
                orderDeliveryLocation: (ReactSession.get("sess_order_kodelokasi")) ? ReactSession.get("sess_order_kodelokasi") : '',
                orderLocPinPoint: (ReactSession.get("sess_order_pinpoint")) ? ReactSession.get("sess_order_pinpoint") : '',
                orderLocJarak: (ReactSession.get("sess_order_jarak")) ? ReactSession.get("sess_order_jarak") : '0',
                orderLocJasaKirim: (ReactSession.get("sess_order_jasakirim")) ? ReactSession.get("sess_order_jasakirim") : '0',
                orderShipmentMethod: '',
                orderShipmentMethodObj: '',
                showDeliveryPicker: false,
            }, () => {
                ReactSession.set("sess_order_delivery", object);

                if(object == 'Biteship'){
                    this.setState({
                        orderLocJasaKirim: '0',
                    }, () => {
                        if(this.state.orderDeliveryLocation && this.state.orderDeliveryType == 'Biteship'){
                            this.callShipmentMethod();
                            this.calculateTotal();
                        }
                    });
                }else if(object == 'Lalamove'){
                    this.setState({
                        orderLocJasaKirim: '0',
                    }, () => {
                        if(this.state.orderDeliveryLocation && this.state.orderDeliveryType == 'Lalamove'){
                            this.callLalamoveService();
                            this.calculateTotal();
                        }
                    });
                }else{
                    this.calculateTotal();
                }
            });
        }
    };

    openWarungModal = () => {
        this.setState({ showWarungModal: true, warungSearch: '' });
    };

    closeWarungModal = () => {
        this.setState({ showWarungModal: false });
    };

    handleSelectWarung = (object) => {
        this.setState({
            orderWarung: object.KodeWarung,
            orderWarungObj: object,
            showWarungModal: false
        });
    };

    clearWarung = () => {
        this.setState({ orderWarung: '', orderWarungObj: '' });
    };

    handleRadioPaymentChange = (object) => {
        this.setState({
            orderPaymentObj: object,
            orderPaymentMethod: object.KodePaymentGateway,
            orderPaymentFee: object.FeeTotal,
            orderPaymentMethodType: object.JenisBank
        }, () => {
            this.callPaymentMethod();
            this.calculateTotal();
        });
    };

    handleRadioShipmentChange = (object) => {
        this.setState({
            orderShipmentMethod: object.company + '|' + object.type,
            orderShipmentMethodObj: object,
            orderLocJasaKirim: object.price,
            showCourierPicker: false,
        }, () => {
            this.calculateTotal();
        });
    };

    handleCommissionChecked = () => {
        this.setState({
            isCommissionChecked: !this.state.isCommissionChecked
        }, () => {
            this.calculateTotal();
        });
    };

    handleBBXPoinChecked = () => {
        this.setState({
            isBBXPoinChecked: !this.state.isBBXPoinChecked
        }, () => {
            this.calculateTotal();
        });
    };

    handleBBXTabunganChecked = () => {
        this.setState({
            isBBXTabunganChecked: !this.state.isBBXTabunganChecked
        }, () => {
            this.calculateTotal();
        });
    };

    // ===== Step 1 (Cart) -> Step 2 (Delivery) =====
    // Aturan sama seperti Cart.js hybrid: goDelivery() -> checkPreOrder()
    goDelivery = () => {
        if(parseInt(this.state.orderTotal) <= 0){
            toast.error("Keranjang kosong atau tidak ada barang yang dipilih!");
            return;
        }

        if(this.state.orderType === 'Retail' && this.state.orderTotalGrosir >= 500000){
            if(window.confirm('Total belanja kamu lebih dari Rp 500.000, jenis harga akan diubah menjadi Grosir untuk mendapatkan harga spesial. Lanjutkan?')){
                ReactSession.set("order_type", "Grosir");
                window.location.reload();
            }
            return;
        }

        if(this.state.orderType === 'Grosir' && this.state.orderTotalGrosir < 500000){
            if(window.confirm('Total belanja kamu kurang dari Rp 500.000, jenis harga akan diubah menjadi Retail atau tambah belanja kamu untuk mendapatkan harga spesial. Lanjutkan?')){
                ReactSession.set("order_type", "Retail");
                window.location.reload();
            }
            return;
        }

        this.checkPreOrder();
    };

    checkPreOrder = () => {
        const preOrderItems = this.state.orderData.filter(item => item.Checked === 't' && parseInt(item.StokPerUnitReal) <= 0);

        if(preOrderItems.length > 0){
            if(window.confirm('Terdapat barang pre order di keranjang, barang pre order membutuhkan waktu lebih lama saat pengiriman, apakah mau dilanjutkan?')){
                this.setState({ step: 'delivery' });
                window.scrollTo(0, 0);
            }
        }else{
            this.setState({ step: 'delivery' });
            window.scrollTo(0, 0);
        }
    };

    // ===== Step 2 (Delivery) -> Step 3 (Payment) =====
    // Aturan sama seperti Delivery.js hybrid: goPayment()
    goPayment = () => {
        if(!this.state.orderDeliveryType){
            toast.error("Kamu belum memilih jenis pengiriman!");
            return;
        }

        if(this.state.orderDeliveryType !== 'Ambil Sendiri'){
            if(!this.state.orderDeliveryLocation){
                toast.error("Kamu belum memilih lokasi pengiriman!");
                return;
            }

            if((this.state.orderDeliveryType === 'Biteship' || this.state.orderDeliveryType === 'Lalamove') && !this.state.orderShipmentMethod){
                toast.error("Kamu belum memilih kurir!");
                return;
            }
        }

        this.setState({ step: 'payment' });
        window.scrollTo(0, 0);
    };

    goBackToCart = () => {
        this.setState({ step: 'cart' });
        window.scrollTo(0, 0);
    };

    goBackToDelivery = () => {
        this.setState({ step: 'delivery' });
        window.scrollTo(0, 0);
    };

    handleUpload = () => {
        if(this.state.kodeMarketPlaceDetail !== ''){
            this.handleCheckPayment();
        }else{
            if(this.state.orderType == 'Grosir'){
                if(parseInt(this.state.orderTotal) >= 500000){
                    this.handleCheckPayment();
                }else{
                    ReactSession.set("order_type", "Retail");

                    toast.error("Total order grosir minimal 500.000, jenis order akan otomatis diubah ke retail.");

                    setTimeout(function() {
                        window.location.reload();
                    }, 1000);
                }
            }else if(this.state.orderType == 'Retail'){
                this.handleCheckPayment();
            }else{
                toast.error("Nominal belanja belum dipilih");
            }
        }
    };

    // Aturan sama seperti Payment.js hybrid: upload()
    handleCheckPayment = () => {
        if(!this.state.orderPaymentMethodType){
            toast.error("Metode pembayaran belum dipilih");
            return;
        }

        if(this.state.orderPaymentMethodType == 'Limit'){
            if(this.state.isBBXTabunganChecked || this.state.isBBXPoinChecked){
                toast.error("Metode pembayaran limit tidak dapat digabung dengan BBX Saving/BBX Poin");
                return;
            }

            if(parseInt(this.state.orderGrandTotal) <= parseInt(this.state.summaryData.credit_limit_raw)){
                this.handleSendUpload();
            }else{
                toast.error("Total order di keranjang tidak boleh melebihi limit yang tersedia");
            }
        }else if(this.state.orderPaymentMethodType == 'Saldo'){
            if(parseInt(this.state.orderGrandTotal) <= parseInt(this.state.summaryData.saldo_waroq_raw)){
                this.handleSendUpload();
            }else{
                toast.error("Total order di keranjang tidak boleh melebihi saldo yang tersedia");
            }
        }else if(this.state.orderPaymentMethodType == 'Bank'){
            this.handleSendUpload();
        }else if(this.state.orderPaymentMethodType == 'e-Money'){
            this.handleSendUpload();
        }else if(this.state.orderPaymentMethodType == 'Credit Card'){
            this.handleSendUpload();
        }else if(this.state.orderPaymentMethodType == 'Fintech'){
            this.handleSendUpload();
        }else{
            toast.error("Metode pembayaran belum dipilih");
        }
    };

    handleSendUpload = () => {
        if(this.state.orderDeliveryType == ''){
            toast.error("Lokasi atau jenis pengiriman belum dipilih");
        }else{
            if(this.state.orderDeliveryType == 'Jasa Kurir' && this.state.orderDeliveryLocation == ''){
                toast.error("Lokasi atau jenis pengiriman belum dipilih");
            }else{
                this.handlePrepareUpload();
            }
        }
    };

    handlePrepareUpload = () => {
        if(parseInt(this.state.orderTotal) > 0){
            if (window.confirm('Apakah order anda sudah sesuai? Klik ok untuk melanjutkan')) {
                if(this.state.isBBXTabunganChecked || this.state.isBBXPoinChecked){
                    if(ReactSession.get("sess_password") === this.state.password_waroq){
                        this.submitOrderSend();
                    }else{
                        toast.error("Password tida sesuai");
                    }
                }else{
                    this.submitOrderSend();
                }
            }else{
                console.log('Cancel.');
            }
        }else{
            toast.error("Anda belum memiliki item di keranjang");
        }
    };

    submitOrderSend = () => {
        const mixcode = ((this.state.orderWarung) ? this.state.orderWarung : this.state.sessUserCode) + '@@@' + this.state.orderCatatan + '@@@';

        Helpers.CreateOrderNew(
            mixcode,
            this.state.sessEmail,
            '',
            this.state.orderKomisiDigunakan,
            this.state.typeCommission,
            this.state.orderDeliveryType,
            this.state.orderDeliveryLocation,
            this.state.orderPaymentMethodType,
            this.state.orderType,
            this.state.orderPaymentMethod,
            this.state.kodeMarketPlaceDetail,
            this.state.branchCode,
            this.state.orderShipmentMethod,
            this.state.orderLocJasaKirim,
            this.state.koinWorksTenor,
            'yes',
            this.state.orderBBXPoinDigunakan,
            this.state.sessKodeNasabah,
            this.state.id_store_bbx,
            "Bayar order",
            this.state.orderBBXTabunganDigunakan
        ).then(res => {
            if(res.length > 0){
                if(res[0].alert == 'success'){
                    setTimeout(function() {
                        window.location.href = './account-orders-details?trxid=' + base64_encode(res[0].KodeTransaksiOrder);
                    }, 1000);
                }

                toast[res[0].alert](res[0].message);
            }else{
                toast.error(Helpers.MSG_ERROR);
            }
        })
    };

    renderStepper = () => {
        const steps = [
            { key: 'cart', label: 'Keranjang' },
            { key: 'delivery', label: 'Pengiriman' },
            { key: 'payment', label: 'Pembayaran' },
        ];
        const activeIndex = steps.findIndex(s => s.key === this.state.step);

        return (
            <div className="checkout-stepper">
                {
                    steps.map((s, i) => (
                        <div className={'checkout-step' + (i === activeIndex ? ' active' : '') + (i < activeIndex ? ' done' : '')} key={s.key}>
                            <span className="checkout-step-dot">{i < activeIndex ? <i className="fi-rs-check"></i> : (i+1)}</span>
                            <span className="checkout-step-label">{s.label}</span>
                            {
                                i < steps.length - 1 && (
                                    <span className="checkout-step-line"></span>
                                )
                            }
                        </div>
                    ))
                }
            </div>
        );
    };

    renderCartStep = () => {
        const allChecked = this.state.orderData.length > 0 && this.state.orderData.every(item => item.Checked === 't');
        const checkedCount = this.state.orderData.filter(item => item.Checked === 't').length;

        return (
            <>
                <div className="cart-toolbar">
                    <span className="cart-toolbar-accent"></span>
                    <span className="cart-toolbar-text">{checkedCount} produk terpilih</span>
                    <a className="cart-toolbar-delete" onClick={() => {this.handleSubmitOrderTemp('delete_all', 0)}}>
                        <i className="fi-rs-trash"></i> Hapus
                    </a>
                </div>

                <div className="cart-item-list">
                    {
                        this.state.orderData.length > 0 ? (
                            this.state.orderData.map((object, i) => (
                                <div className={'cart-item-card' + (object.StokPerUnitReal <= 0 ? ' preorder' : '')} key={i}>
                                    <input type="checkbox" className="cart-item-checkbox" checked={object.Checked === 't'} onChange={() => {this.handleToggleChecked(object)}}/>
                                    <img className="cart-item-thumb" src={object.img_url} alt=""/>
                                    <div className="cart-item-info">
                                        <div className="cart-item-name">{object.NamaBarang}</div>
                                        <div className="cart-item-price-row">
                                            <strong>Rp {this.state.orderType == 'Grosir' ? object.TotalHargaGrosirFormatTerkecil : object.TotalHargaRetailFormatTerkecil}</strong>
                                            <img src={this.state.orderType == 'Grosir' ? './assets/imgs/icon/ic_grosir.png' : './assets/imgs/icon/ic_retail.png'} width="16" alt=""/>
                                            {
                                                object.StokPerUnitReal <= 0 && (
                                                    <span className="cart-item-preorder-badge">Pre Order</span>
                                                )
                                            }
                                        </div>
                                        <div className="cart-item-meta">
                                            Estimasi Poin: {this.state.orderType == 'Grosir' ? object.KomisiGrosirFormat : object.KomisiRetailFormat} &middot; Berat: {object.TotalBerat} gr
                                        </div>
                                        <div className="cart-item-footer">
                                            <div className="cart-item-unit">
                                                <span>Unit</span>
                                                <strong>{object.UnitBarang}</strong>
                                            </div>
                                            <div className="product-qty-box cart-item-qty-box">
                                                <button type="button" className="product-qty-btn" onClick={() => {this.handleSubmitOrderTemp(object.DetailId, object.QtyOrder-1, object.Checked)}}>-</button>
                                                <input className="product-qty-input" type="text" value={object.QtyOrder} readOnly/>
                                                <button type="button" className="product-qty-btn plus" onClick={() => {this.handleSubmitOrderTemp(object.DetailId, object.QtyOrder+1, object.Checked)}}>+</button>
                                            </div>
                                            <button type="button" className="cart-item-delete-btn" onClick={() => {this.handleSubmitOrderTemp(object.DetailId, 0, object.Checked)}}>
                                                <i className="fi-rs-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="order-empty">
                                <i className="fi-rs-shopping-cart"></i>
                                <p>Keranjang kamu masih kosong</p>
                            </div>
                        )
                    }
                </div>

                <div className="checkout-bottom-bar">
                    <div className="checkout-bottom-bar-inner">
                        <label className="cart-selectall">
                            <input type="checkbox" checked={allChecked} onChange={() => {this.handleToggleSelectAll()}}/>
                            <span>Semua</span>
                        </label>
                        <div className="checkout-bottom-total">
                            <div className="checkout-bottom-total-label">Total</div>
                            <div className="checkout-bottom-total-value">Rp {this.state.orderTotal.toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</div>
                        </div>
                        <button type="button" className="auth-btn-primary checkout-bottom-btn" onClick={() => {this.goDelivery()}}>Beli ({checkedCount})</button>
                    </div>
                </div>
            </>
        );
    };

    renderDeliveryStep = () => {
        const deliveryLabels = {
            'Ambil Sendiri': { icon: 'fi-rs-shop', title: 'Ambil Sendiri' },
            'Jasa Kurir': { icon: 'fi-rs-package', title: 'WAROQ Delivery' },
            'Biteship': { icon: 'fi-rs-package', title: 'Kurir Pengiriman' },
            'Lalamove': { icon: 'fi-rs-package', title: 'Lalamove' },
        };
        const current = deliveryLabels[this.state.orderDeliveryType] || deliveryLabels['Ambil Sendiri'];
        const freeOngkir = parseInt(this.state.orderTotal) > 1000000 && this.state.orderDeliveryType === 'Jasa Kurir';

        return (
            <>
                {
                    this.state.orderDeliveryType !== 'Ambil Sendiri' && (
                        <div className="detail-card">
                            <div className="detail-card-head">
                                <span className="detail-card-accent"></span>
                                <span className="detail-card-title">Alamat Pengiriman</span>
                            </div>
                            <a href={'./location'} className="delivery-card">
                                <span className="delivery-icon"><i className="fi-rs-marker"></i></span>
                                <span className="delivery-card-body">
                                    <span className="delivery-card-title">{this.state.orderLocPinPoint ? this.state.orderLocPinPoint : 'Pilih lokasi pengiriman'}</span>
                                </span>
                                <i className="fi-rs-angle-small-right delivery-chevron"></i>
                            </a>
                        </div>
                    )
                }

                <div className="detail-card">
                    <div className="detail-card-head">
                        <span className="detail-card-accent"></span>
                        <span className="detail-card-title">Metode Pengiriman</span>
                    </div>

                    {
                        !this.state.showDeliveryPicker ? (
                            <div className="delivery-card delivery-card-expanded" onClick={() => this.setState({showDeliveryPicker: true})}>
                                <div className="delivery-card-row">
                                    <span className="delivery-icon"><i className={current.icon}></i></span>
                                    <span className="delivery-card-body">
                                        <span className="delivery-card-title">{current.title}</span>
                                    </span>
                                    <i className="fi-rs-angle-small-right delivery-chevron"></i>
                                </div>

                                {
                                    this.state.orderDeliveryType !== 'Ambil Sendiri' && (
                                        <>
                                            <div className="delivery-detail-row">
                                                <i className="fi-rs-marker"></i>
                                                <span>Jarak dengan gudang {(parseFloat(this.state.orderLocJarak)/1000).toFixed(2)} Km</span>
                                            </div>
                                            {
                                                this.state.orderDeliveryType === 'Jasa Kurir' && (
                                                    <div className="delivery-detail-row">
                                                        <i className="fi-rs-clock"></i>
                                                        <span>Estimasi pengiriman 3 - 5 hari kerja</span>
                                                    </div>
                                                )
                                            }
                                            <div className="delivery-detail-row">
                                                <i className="fi-rs-dollar"></i>
                                                <span>Biaya pengiriman Rp <strong>{parseInt(freeOngkir ? 0 : this.state.orderLocJasaKirim).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</strong></span>
                                            </div>
                                        </>
                                    )
                                }

                                {
                                    this.state.orderDeliveryType === 'Ambil Sendiri' && (
                                        <>
                                            <div className="delivery-divider"></div>
                                            <div className="delivery-detail-row">
                                                <i className="fi-rs-info"></i>
                                                <span>
                                                    {
                                                        this.state.branchCode=='CBNG-18-020001' ? 'Mayapada Tower 2 (Gudang Waroq/Gudang BBX Mart), Jl. Jend. Sudirman No.Kav. 27, Kuningan, Karet, Kec. Setiabudi, Jakarta Selatan'
                                                        : this.state.branchCode=='CBNG-18-020002' ? 'RUKO MAYAPADA, Jl. Wibawa Mukti II RT.006/RW.001, Jatiluhur, Kec. Jatiasih, Kota Bekasi'
                                                        : this.state.branchCode=='CBNG-18-020003' ? 'Mayapada Hospital Surabaya (MHSB), Jl. Mayjen Sungkono No.20, Pakis, Kec. Sawahan, Surabaya'
                                                        : ''
                                                    }
                                                    <br/>Jam operasional: Senin-Jumat 08.00-18.00, Sabtu 10.00-17.00, Minggu tutup.
                                                </span>
                                            </div>
                                        </>
                                    )
                                }

                                {
                                    this.state.orderDeliveryType === 'Jasa Kurir' && (
                                        <>
                                            <div className="delivery-divider"></div>
                                            <div className="delivery-detail-row">
                                                <i className="fi-rs-info"></i>
                                                <span>Gratis biaya pengiriman dengan minimal total belanja di keranjang sebesar Rp 1.000.000</span>
                                            </div>
                                        </>
                                    )
                                }
                            </div>
                        ) : (
                            <>
                                {
                                    Object.keys(deliveryLabels).map((key) => (
                                        <div key={key} className="delivery-card" onClick={() => {this.handleRadioChange(key)}}>
                                            <span className="delivery-icon"><i className={deliveryLabels[key].icon}></i></span>
                                            <span className="delivery-card-body">
                                                <span className="delivery-card-title">{deliveryLabels[key].title}</span>
                                            </span>
                                            {
                                                this.state.orderDeliveryType === key && (
                                                    <span className="modal-picker-item-check"><i className="fi-rs-check"></i></span>
                                                )
                                            }
                                        </div>
                                    ))
                                }
                            </>
                        )
                    }

                    {
                        (this.state.orderDeliveryType === 'Biteship' || this.state.orderDeliveryType === 'Lalamove') && !this.state.showDeliveryPicker && (
                            this.state.loadingQuotation ? (
                                <div className="delivery-card delivery-card-loading">
                                    <span className="delivery-spinner"></span>
                                    <span className="delivery-card-body">
                                        <span className="delivery-card-title">Menghitung estimasi biaya...</span>
                                    </span>
                                </div>
                            ) : !this.state.showCourierPicker ? (
                                this.state.loadingCourier ? (
                                    <div className="delivery-card delivery-card-loading">
                                        <span className="delivery-spinner"></span>
                                        <span className="delivery-card-body">
                                            <span className="delivery-card-title">Memuat kurir...</span>
                                        </span>
                                    </div>
                                ) : (
                                    <div className="delivery-card" onClick={() => this.setState({showCourierPicker: true})}>
                                        <span className="delivery-icon"><i className="fi-rs-package"></i></span>
                                        <span className="delivery-card-body">
                                            <span className="delivery-card-title">{this.state.orderShipmentMethodObj ? this.state.orderShipmentMethodObj.courier_name + (this.state.orderShipmentMethodObj.duration ? ' (' + this.state.orderShipmentMethodObj.duration + ')' : '') : 'Pilih kurir'}</span>
                                            {
                                                this.state.orderShipmentMethodObj && (
                                                    <span className="delivery-card-subtitle">{this.state.orderShipmentMethodObj.courier_service_name}: Rp {parseFloat(this.state.orderShipmentMethodObj.price).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</span>
                                                )
                                            }
                                        </span>
                                        <i className="fi-rs-angle-small-right delivery-chevron"></i>
                                    </div>
                                )
                            ) : this.state.loadingCourier ? (
                                <div className="delivery-card delivery-card-loading">
                                    <span className="delivery-spinner"></span>
                                    <span className="delivery-card-body">
                                        <span className="delivery-card-title">Memuat kurir...</span>
                                    </span>
                                </div>
                            ) : this.state.orderDeliveryType === 'Biteship' ? (
                                (this.state.generateShipmentMethodList || []).map((object, i) => {
                                    const code = object.company + '|' + object.type;
                                    const active = this.state.orderShipmentMethod === code;
                                    return (
                                        <div key={i} className="delivery-card" onClick={() => {this.handleRadioShipmentChange(object)}}>
                                            <span className="delivery-card-body">
                                                <span className="delivery-card-title">{object.courier_name} ({object.duration})</span>
                                                <span className="delivery-card-subtitle">{object.courier_service_name}: Rp {parseFloat(object.price).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</span>
                                            </span>
                                            {
                                                active && (
                                                    <span className="modal-picker-item-check"><i className="fi-rs-check"></i></span>
                                                )
                                            }
                                        </div>
                                    );
                                })
                            ) : (
                                (this.state.lalamoveServiceList || []).map((object, i) => {
                                    const serviceKey = object.ServiceKey || object.Servicekey || object.serviceKey || object.servicekey;
                                    const vehicleName = object.VehicleName || object.Vehiclename || object.vehicleName || object.vehiclename;
                                    const loadLabel = object.LoadValueLabel || object.Loadvaluelabel || object.loadValueLabel || object.loadvaluelabel;
                                    const description = object.Description || object.description;
                                    const active = this.state.orderShipmentMethod === serviceKey;
                                    return (
                                        <div key={i} className="delivery-card" onClick={() => {this.handleSelectLalamoveService(object)}}>
                                            <span className="delivery-card-body">
                                                <span className="delivery-card-title">{vehicleName}</span>
                                                <span className="delivery-card-subtitle">{description}{loadLabel ? ' · ' + loadLabel : ''}</span>
                                            </span>
                                            {
                                                active && (
                                                    <span className="modal-picker-item-check"><i className="fi-rs-check"></i></span>
                                                )
                                            }
                                        </div>
                                    );
                                })
                            )
                        )
                    }
                </div>

                <div className="detail-card">
                    <div className="detail-card-head">
                        <span className="detail-card-accent"></span>
                        <span className="detail-card-title">Informasi Tambahan (opsional)</span>
                    </div>

                    {
                        this.state.orderWarungObj ? (
                            <div className="delivery-card" onClick={() => this.openWarungModal()}>
                                <span className="delivery-icon"><i className="fi-rs-shop"></i></span>
                                <span className="delivery-card-body">
                                    <span className="delivery-card-title">{this.state.orderWarungObj.NamaWarung}</span>
                                    <span className="delivery-card-subtitle">{this.state.orderWarungObj.KodeWarung}</span>
                                </span>
                                <i
                                    className="fi-rs-cross-circle delivery-chevron"
                                    onClick={(e) => { e.stopPropagation(); this.clearWarung(); }}
                                ></i>
                            </div>
                        ) : (
                            <div className="delivery-card" onClick={() => this.openWarungModal()}>
                                <span className="delivery-icon"><i className="fi-rs-shop"></i></span>
                                <span className="delivery-card-body">
                                    <span className="delivery-card-title">Pilih Warung Tujuan</span>
                                </span>
                                <i className="fi-rs-angle-small-right delivery-chevron"></i>
                            </div>
                        )
                    }

                    <div className="delivery-note-input">
                        <textarea
                            placeholder="Catatan order (opsional)"
                            value={this.state.orderCatatan}
                            onChange={(e) => this.setState({ orderCatatan: e.target.value })}
                            rows={2}
                        ></textarea>
                        {
                            this.state.orderCatatan && (
                                <i className="fi-rs-cross-circle" onClick={() => this.setState({ orderCatatan: '' })}></i>
                            )
                        }
                    </div>
                </div>

                <div className="detail-card">
                    <div className="detail-card-head">
                        <span className="detail-card-accent"></span>
                        <span className="detail-card-title">Cek ringkasan belanjamu, yuk</span>
                    </div>
                    <div className="detail-info-box">
                        <div className="detail-info-row">
                            <i className="fi-rs-shopping-bag"></i>
                            <span className="detail-info-label">Total Belanja</span>
                            <span className="detail-info-value">Rp {this.state.orderTotal.toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</span>
                        </div>
                        <div className="detail-info-row detail-info-row-last">
                            <i className="fi-rs-package"></i>
                            <span className="detail-info-label">Ongkos Kirim</span>
                            <span className="detail-info-value">Rp {parseInt(freeOngkir ? 0 : this.state.orderLocJasaKirim).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</span>
                        </div>
                    </div>
                </div>

                <div className="checkout-bottom-bar">
                    <div className="checkout-bottom-bar-inner checkout-bottom-bar-split">
                        <button type="button" className="auth-btn-outline" onClick={() => {this.goBackToCart()}}>Kembali</button>
                        <button type="button" className="auth-btn-primary" onClick={() => {this.goPayment()}}>Lanjut</button>
                    </div>
                </div>

                {this.renderWarungModal()}
            </>
        );
    };

    renderWarungModal = () => {
        const filtered = (this.state.warungData || []).filter((object) => {
            if(!this.state.warungSearch) return true;
            const str = this.state.warungSearch.toUpperCase();
            return (object.KodeWarung || '').toUpperCase().includes(str) || (object.NamaWarung || '').toUpperCase().includes(str);
        });

        return (
            <Modal
                size={'md'}
                isOpen={this.state.showWarungModal}
                toggle={() => { this.closeWarungModal() }}
                contentClassName="modal-picker-content">
                <ModalBody className="modal-picker-body">
                    <div className="modal-picker-header">
                        <div className="modal-picker-title">
                            <span className="modal-picker-icon"><i className="fi-rs-shop"></i></span>
                            Pilih Warung Tujuan
                        </div>
                        <button type="button" className="modal-picker-close" onClick={() => { this.closeWarungModal() }} aria-label="Tutup">
                            <i className="fi-rs-cross"></i>
                        </button>
                    </div>

                    <div className="modal-picker-search">
                        <i className="fi-rs-search"></i>
                        <input
                            type="text"
                            placeholder="Cari warung ..."
                            value={this.state.warungSearch}
                            onChange={(e) => this.setState({ warungSearch: e.target.value })}
                        />
                    </div>

                    <div className="modal-picker-list">
                        {
                            filtered.length > 0 ? (
                                filtered.map((object, i) => {
                                    const active = object.KodeWarung === this.state.orderWarung;
                                    return (
                                        <div
                                            key={i}
                                            className={'modal-picker-item' + (active ? ' active' : '')}
                                            onClick={() => { this.handleSelectWarung(object) }}
                                        >
                                            <span className="modal-picker-item-icon">
                                                <i className="fi-rs-shop"></i>
                                            </span>
                                            <span className="modal-picker-item-text">
                                                <span className="modal-picker-item-title">{object.NamaWarung}</span>
                                                <span className="modal-picker-item-subtitle">{object.KodeWarung}</span>
                                            </span>
                                            {
                                                active && (
                                                    <span className="modal-picker-item-check"><i className="fi-rs-check"></i></span>
                                                )
                                            }
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="modal-picker-empty">
                                    <i className="fi-rs-shop" style={{ fontSize: '30px', color: '#ddd' }}></i>
                                    <p>Warung tidak ditemukan</p>
                                </div>
                            )
                        }
                    </div>
                </ModalBody>
            </Modal>
        );
    };

    renderPaymentStep = () => {
        return (
            <>
                <div className="detail-card">
                    <div className="detail-card-head">
                        <span className="detail-card-accent"></span>
                        <span className="detail-card-title">Metode Pembayaran</span>
                    </div>

                    {
                        this.state.paymentData.map((object, i) => {
                            const active = this.state.orderPaymentMethod === object.KodePaymentGateway;
                            let saldoLabel = object.Fullname;
                            if(object.KodePaymentGateway == 'Limit'){ saldoLabel = 'Saldo: Rp ' + this.state.summaryData.credit_limit; }
                            else if(object.KodePaymentGateway == 'Saldo'){ saldoLabel = 'Saldo: Rp ' + this.state.summaryData.saldo_waroq; }
                            else if(object.KodePaymentGateway == 'KPG-0017'){ saldoLabel = 'Saldo: Rp ' + this.state.summaryData.KoinWorksLimitFormat; }

                            return (
                                <div key={i} className={'modal-picker-item modal-picker-item-flat' + (active ? ' active' : '')} onClick={() => {this.handleRadioPaymentChange(object)}}>
                                    <img src={object.Logo} alt="" style={{width: '32px', height: '32px', marginRight: '12px', objectFit: 'contain'}}/>
                                    <span className="modal-picker-item-text">
                                        <span className="modal-picker-item-title">{object.Shortname}</span>
                                        <span className="modal-picker-item-subtitle">{saldoLabel}</span>
                                    </span>
                                    {
                                        active && (
                                            <span className="modal-picker-item-check"><i className="fi-rs-check"></i></span>
                                        )
                                    }
                                </div>
                            );
                        })
                    }

                    {
                        this.state.orderPaymentMethod === 'KPG-0017' && (
                            <div className="auth-input-group" style={{marginTop: '10px'}}>
                                <i className="fi-rs-calendar auth-input-icon"></i>
                                <select className="location-select" onChange={e => this.setState({koinWorksTenor: e.target.value})}>
                                    {
                                        Helpers.arrKoinWorksTenor.map((object, i) => (
                                            <option key={i} value={object.value}>{object.label}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        )
                    }
                </div>

                <div className="detail-card">
                    <div className="detail-card-head">
                        <span className="detail-card-accent"></span>
                        <span className="detail-card-title">Gunakan Poin & Saldo</span>
                    </div>

                    <div className="checkout-wallet-row">
                        <label className="checkout-wallet-label">
                            <input type="checkbox" checked={this.state.isCommissionChecked} onChange={() => {this.handleCommissionChecked()}}/>
                            <span>Waroq Poin <small>(Saldo: {parseInt(this.state.saldoCommission).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')})</small></span>
                        </label>
                        <strong>Rp {parseFloat(this.state.orderKomisiDigunakan).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</strong>
                    </div>

                    {
                        !this.state.sessKodeNasabah ? (
                            <div className="checkout-wallet-row">
                                <span>Saldo BBX</span>
                                <a href={'./bbx-poin-login?redirectUrl='+ base64_encode(window.location.href)} style={{color: '#F47626', fontWeight: 700}}>Hubungkan</a>
                            </div>
                        ) : (
                            <>
                                <div className="checkout-wallet-row">
                                    <label className="checkout-wallet-label">
                                        <input type="checkbox" checked={this.state.isBBXTabunganChecked} onChange={() => {this.handleBBXTabunganChecked()}}/>
                                        <span>BBX Tabungan <small>(Saldo: {parseInt(this.state.saldoBBXTabungan).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')})</small></span>
                                    </label>
                                    <strong>Rp {parseFloat(this.state.orderBBXTabunganDigunakan).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</strong>
                                </div>
                                <div className="checkout-wallet-row">
                                    <label className="checkout-wallet-label">
                                        <input type="checkbox" checked={this.state.isBBXPoinChecked} onChange={() => {this.handleBBXPoinChecked()}}/>
                                        <span>BBX Poin <small>(Saldo: {parseInt(this.state.saldoBBXPoin).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')})</small></span>
                                    </label>
                                    <strong>Rp {parseFloat(this.state.orderBBXPoinDigunakan).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</strong>
                                </div>
                            </>
                        )
                    }

                    {
                        (this.state.isBBXTabunganChecked || this.state.isBBXPoinChecked) && (
                            <div className="auth-input-group" style={{marginTop: '12px'}}>
                                <i className="fi-rs-lock auth-input-icon"></i>
                                <input value={this.state.password_waroq} onChange={e => this.setState({password_waroq: e.target.value})}
                                       placeholder="Masukkan Password Waroq"
                                       type="password"/>
                            </div>
                        )
                    }
                </div>

                <div className="detail-card">
                    <div className="detail-card-head">
                        <span className="detail-card-accent"></span>
                        <span className="detail-card-title">Rincian Pembayaran</span>
                    </div>
                    <div className="detail-summary-box" style={{marginTop: 0}}>
                        <div className="detail-summary-row">
                            <span>Total Keranjang</span>
                            <span>Rp {this.state.orderTotal.toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</span>
                        </div>
                        <div className="detail-summary-row">
                            <span>Pengiriman</span>
                            <span>Rp {parseInt(this.state.orderLocJasaKirim).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</span>
                        </div>
                        <div className="detail-summary-row">
                            <span>Biaya Admin</span>
                            <span>Rp {parseInt(this.state.orderPaymentCharge).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</span>
                        </div>
                        <div className="detail-summary-divider"></div>
                        <div className="detail-summary-row detail-summary-total">
                            <span>Grand Total</span>
                            <span>Rp {parseFloat(this.state.orderGrandTotal).toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</span>
                        </div>
                    </div>
                </div>

                <div className="checkout-bottom-bar">
                    <div className="checkout-bottom-bar-inner checkout-bottom-bar-split">
                        <button type="button" className="auth-btn-outline" onClick={() => {this.goBackToDelivery()}}>Kembali</button>
                        <button type="button" className="auth-btn-primary" onClick={() => {this.handleUpload()}}>Submit Order</button>
                    </div>
                </div>
            </>
        );
    };

    render() {
        return (
            <>
                <main className="main pages checkout-page-wrap">
                    <div className="detail-topbar">
                        <a href="./" className="detail-topbar-back"><i className="fi-rs-arrow-small-left"></i></a>
                        <h1 className="detail-topbar-title">Checkout</h1>
                    </div>

                    {this.renderStepper()}

                    <div className="detail-wrap">
                        {this.state.step === 'cart' && this.renderCartStep()}
                        {this.state.step === 'delivery' && this.renderDeliveryStep()}
                        {this.state.step === 'payment' && this.renderPaymentStep()}
                    </div>
                </main>
            </>
        );
    }
}

export default Checkout;
